export default class Button {
  constructor(buttonElement) {
    this.button = buttonElement

    this.bindToolTip()
  }

  bindToolTip() {
    if (this.button.getAttribute('data-tooltip') === 'tooltip') {
      jQuery(this.button).tooltip({
        title: function() {
          if (this.disabled) return this.getAttribute('data-disabled-title')

          return this.getAttribute('data-title')
        },
      })
    }
  }

  open() {
    if (this.openable()) this.button.classList.add('button--open')
  }

  close() {
    if (this.openable()) this.button.classList.remove('button--open')
  }

  opened() {
    return this.button.classList.contains('button--open')
  }

  openable() {
    return this.button.getAttribute('data-openable') === 'openable'
  }
}
